import {NgModule} from '@angular/core';
import {OccupationalProfileOrientationComponent} from './occupational-profile-orientation.component';
import {CommonModule} from '@angular/common';
import {ConfigService} from '../config/config.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        ConfigService
    ],
    declarations: [
        OccupationalProfileOrientationComponent
    ],
    exports: [
        OccupationalProfileOrientationComponent
    ]
})

export class OrientationModule {

}
